import { createVuetify } from "vuetify"
import type { ThemeDefinition } from "vuetify"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"
import { fa } from "vuetify/iconsets/fa"

import { customSVGs } from "~/assets/customSVGs"

const somaTheme: ThemeDefinition = {
  dark: false,
  colors: {
    yellowBack: "#FFF1AE",
    yellowActive: "#F9D805",
    blackActive: "#221B00",
    whiteishBack: "#FBFBFB",
    grayBack: "#ECECEC",
    brightGray: "#EBEBEB",
    quinary: "#006D33",
    tertiaryContainer: "#C5E6FD",
    tertiaryContainerHover: "#B5D3EA",
    tertiaryContainerPressed: "#ADCADF",
    tertiaryContainerLightened: "#E2F2FE",
    eklase: "#009AE3",
    mykoob: "#292C39",
    eliis: "#A5C365",
    maillogin: "FFFADF",
    loginGray: "#9E956C",
    landingGreen: "#4FBC63",
    landingOrange: "#FA4C42",
    landingCream: "#FBF5E4",
    landingFooter: "#FAE68F",
  },
}
const aliases = {
  collapse: "fa-thin fa-chevron-up",
  complete: "fa-light fa-check",
  cancel: "fa-light fa-times-circle",
  close: "fa-light fa-times",
  delete: "fa-light fa-times-circle",
  clear: "fa-light fa-times-circle",
  success: "fa-light fa-check-circle",
  info: "fa-light fa-info-circle",
  warning: "fa-light fa-exclamation",
  error: "fa-light fa-exclamation-triangle",
  prev: "fa-thin fa-chevron-left",
  next: "fa-thin fa-chevron-right",
  checkboxOn: "fa-light fa-check-square",
  checkboxOff: "fa-light fa-square",
  checkboxIndeterminate: "fa-light fa-minus-square",
  delimiter: "fa-light fa-circle",
  sort: "fa-light fa-sort-up",
  expand: "fa-thin fa-chevron-down",
  menu: "fa-light fa-bars",
  subgroup: "fa-light fa-caret-down",
  dropdown: "fa-light fa-caret-down",
  radioOn: "fa-light fa-dot-circle",
  radioOff: "fa-light fa-circle",
  edit: "fa-light fa-edit",
  ratingEmpty: "fa-light fa-star",
  ratingFull: "fa-light fa-star",
  ratingHalf: "fa-light fa-star-half",
  loading: "fa-light fa-sync",
  first: "fa-light fa-step-backward",
  last: "fa-light fa-step-forward",
  unfold: "fa-light fa-arrows-alt-v",
  file: "fa-light fa-paperclip",
  plus: "fa-light fa-plus",
  minus: "fa-light fa-minus",
}

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components,
    directives,
    theme: {
      defaultTheme: "somaTheme",
      themes: {
        somaTheme,
      },
    },
    icons: {
      defaultSet: "fa",
      aliases,
      sets: {
        fa,
        custom: customSVGs,
      },
    },
  })

  nuxtApp.vueApp.use(vuetify)
})
